// Custom hook to handle the setting of request status
const useSetRequestStatus = ({ setRequestStatus }) => {
  // Function to set the status of one or more requests
  const handleSetStatus = (
    // Default parameter is an array with a single object representing a 'prepare' request in 'loading' status
    keys = [{ key: "prepare", status: "loading", hidden: false }]
  ) => {
    // Call the setRequestStatus function with a function argument
    setRequestStatus((prev) => {
      // Reduce the keys array to an object with the same structure as the previous state
      const obj = keys.reduce(
        (acc, { key, status, hidden }) => ({
          // Spread the accumulator and add/overwrite the key with the new status and hidden values
          ...acc,
          [key]: { ...prev[key], status, hidden },
        }),
        {} // Initial value of the accumulator is an empty object
      );
      // Return a new state object by spreading the previous state and the new object
      return { ...prev, ...obj };
    });
  };
  return { handleSetStatus };
};

export default useSetRequestStatus;